"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_SYSTEM_LANG = exports.UPDATE_SYSTEM_LANG = void 0;
const react_1 = __importDefault(require("react"));
const schemaComponents_1 = require("@/schemaComponents");
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const schema_1 = __importDefault(require("./schema"));
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
exports.UPDATE_SYSTEM_LANG = route_1.SYSTEM_LANG.sub("/edit", Lang);
exports.ADD_SYSTEM_LANG = route_1.SYSTEM_LANGS.sub("/edit/new", Lang);
function Lang({ langId }) {
    (0, auth_1.useUserPageAuthorization)();
    const { data, loading, set, remove, isEditing } = (0, models_hook_1.useSystemLangDoc)({
        langId,
    });
    const parameter = {
        title: isEditing ? "言語詳細" : "言語新規作成",
        schema: (0, schema_1.default)(),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: set,
        },
        remove: isEditing ? { handler: remove } : undefined,
        backPath: (0, index_1.resolveRoute)("LIST_SYSTEM_LANGS", {}),
    };
    return (react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: data, parameter: parameter, loading: isEditing && loading, editModeEnabled: true }));
}
exports.default = Lang;
